import script from "./ModalConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./ModalConfirmation.vue?vue&type=style&index=0&id=a65e5c5c&lang=scss"

const __exports__ = script;

export default __exports__